<template>
  <RouterView></RouterView>
</template>

<script>
</script>

<style>
</style>
